import React, { Component } from 'react'
import { Modal} from 'antd'
import 'antd/dist/antd.css'; // or 'antd/dist/antd.less'
import Notification from '../../common/Notification'
import PropagateLoader from '../../common/SubmitingForm'
import ajax from '../../utils/ajax'
import functions from '../../utils/functions'


class AddHospitalCategory extends Component {
  state = {
    userId: functions.sessionGuard(),
    categoryName:"",
    categoryCode:"",
    load:""
  }

  handleCancel = () => {
    const sent = this.props
    this.setState({ visible: false })
    sent.handleCancel(false)
  }


  categoryName = (value)=> {
    this.setState({ categoryName: value.target.value })
  }
  categoryCode = (value)=> {
    this.setState({ categoryCode: value.target.value })
  }


  onPressAddCategory= async (event)=>{
    event.preventDefault()
    const { categoryName,categoryCode} = this.state

    if (categoryName.length > 0 && 
      categoryCode.length >0 ) {
        this.setState({
          type: '',
          info: '',
          load:<PropagateLoader/>
        })

          //fetch category from the API
          const server_response = await ajax.createCategory(categoryName, categoryCode,this.state.userId)

          if (server_response.status === "OK") {
            this.setState({
              type: 'alert alert-success',
              info: server_response.details.message,
              load: '',
            })
            window.location.reload()

        } else {

          this.setState({
            type: 'alert alert-danger',
            info: server_response.details.message,
            load: '',
          })

        }


      }else{
        this.setState({
          type: 'alert alert-danger',
          info: 'Please be advised to fill in all required fields - All fields are required',
          load:'',
        })
      }
  }


  render() {
    return (

        <Modal
        title = {"ADD CLINIC - HOSPTIAL CATEGORY"}
        centered
        bodyStyle={{ paddingBottom: '0px', paddingTop: '0px' }}
        visible={this.props.visible.visible}
    
        maskClosable={false}
        footer={[null]}
        maskTransitionName=""
        onCancel={this.handleCancel}
        width={700}
        okButtonProps={{ disabled: true }}
        cancelButtonProps={{ disabled: false }}
      >

<br/>
<div class="row">
<div class="col-sm-12 mobile-inputs">

{this.state.load}
  <Notification
        message={{
          type: this.state.type,
          info: this.state.info,
        }}
    />

<form method="post" onSubmit={this.onPressAddCategory}>
<div class="form-group row">
<div class="col-sm-6">
<input type="text" onChange={this.categoryName} class="form-control form-txt-primary" placeholder="Category Name"/>
</div>
<div class="col-sm-6">
<input type="text" onChange={this.categoryCode} class="form-control form-txt-primary" placeholder="Category Code"/>
</div>
</div>

<div class="form-group row">
<div class="col-sm-6">
</div>

</div>
<div class="row">
<div class="col-sm-4 card-header-right" >
<button type="submit" class="btn btn-primary btn-block mb-3">Add Hospital Category</button>
 </div>
 </div>
</form>
</div>
</div>


     
      </Modal>

    )}}

    export default AddHospitalCategory